const Header = ((($) => {

  let $window;
  let header;
  let scrollTop;

  function init() {
    $window = $(window);
    header = $('.Header');

    scrollTop = $window.scrollTop();

    if (scrollTop >= 1) {
      header.addClass('fixed');
    }
    else {
      header.removeClass('fixed');
    }

    _attachEvents();
    $('.open-mobile-nav').on('click', function() {
      $(this).toggleClass('is-active');
      $('body').toggleClass('overflow-h');
      $('.Header-nav').toggleClass('show');
      return false;
    });
    $('.nav-item').on('click', function() {
      $(this);
      $('.open-mobile-nav').removeClass('is-active');
      $('body').removeClass('overflow-h');
      $('.Header-nav').removeClass('show');
    });

  }

  function _attachEvents() {
    $window.scroll(_handleWindowScroll);
  }

  function _handleWindowScroll() {

    scrollTop = $window.scrollTop();

    if (scrollTop >= 1) {
      header.addClass('fixed');
    }
    else {
      header.removeClass('fixed');
    }
  }

  return {
    init,
  };

}))(jQuery);

export default Header;



// WEBPACK FOOTER //
// ./src/static/js/modules/header.js